import React, { useState, useEffect } from 'react';

function SMSManager() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

 
  const handleSend = async (e) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_GSM_SMS_API_URL}/gsm-file/gsm2.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `action=send&phoneNumber=${phoneNumber}&message=${message}`,
    });
    const data = await response.json();
    console.log(data);
    alert('Message sent!');
    // Optionally, refresh the message list after sending
    fetchMessages();
    setPhoneNumber('');
    setMessage('');
  };

  const fetchMessages = async () => {
    const response = await fetch(`${process.env.REACT_APP_GSM_SMS_API_URL}/gsm-file/gsm2.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: 'action=read',
    });
    const data = await response.json();
    setMessages(data);
  };

  const handleDelete = async (index) => {
      const response = await fetch(`${process.env.REACT_APP_GSM_SMS_API_URL}/gsm-file/gsm2.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=delete&index=${index}`
    });
    const result = await response.json();
    console.log(result);
    fetchMessages();
  }

  useEffect(() => {
    fetchMessages(); // Initial message load
    const interval = setInterval(fetchMessages, 15000); // Poll for new messages every 5 seconds
    return () => clearInterval(interval); // Cleanup interval
  }, []);

  return (
    <div>
      <h2>Send SMS</h2>
      <form onSubmit={handleSend}>
        <input
          type="text"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <textarea
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type="submit">Send</button>
      </form>

      <h2>Received Messages</h2>
      <ul>
        {messages && messages.map((message) => (
          <li key={message.id}>
            <strong>From:</strong> {message.message_from} <br />
            <strong>Date:</strong> {message.received_at} <br />
            <strong>Text:</strong> {message.message}
            <button onClick={() => handleDelete(message.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SMSManager;